// GENERATED by `php artisan permissions:export` (incept-api). Do not edit by hand.
// Tenant: core (no tenant merge) (core merged with the tenant's auth permissions config).
// Regenerate from incept-api after changing the permissions config.
export const Permissions = {
  ActionsBrokersApplicationUpdate: 'actions.brokers.application.update',
  ActionsView: 'actions.view',
  ActivitiesView: 'activities.view',
  AiDealSummaryCreate: 'ai_deal_summary.create',
  AiDealSummaryView: 'ai_deal_summary.view',
  AiDealsSummaryCreate: 'ai_deals_summary.create',
  AiDealsSummaryView: 'ai_deals_summary.view',
  AiQuickQuoteCreate: 'ai_quick_quote.create',
  ApiTesting: 'api.testing',
  AssigneeUpdate: 'assignee.update',
  BrokersCreate: 'brokers.create',
  BrokersDelete: 'brokers.delete',
  BrokersRestore: 'brokers.restore',
  BrokersTwoFactorAuthenticationUpdate: 'brokers.two_factor_authentication.update',
  BrokersUpdate: 'brokers.update',
  BrokersView: 'brokers.view',
  DocsCreate: 'docs.create',
  DocsDelete: 'docs.delete',
  DocsDownload: 'docs.download',
  DocsUpdate: 'docs.update',
  DocsView: 'docs.view',
  DocumentAnyFieldsAnyDelete: 'document.*.fields.*.delete',
  DocumentAnyFieldsAnyUpdate: 'document.*.fields.*.update',
  DocumentAnySetsAnyCreate: 'document.*.sets.*.create',
  DocumentAnySetsAnyDelete: 'document.*.sets.*.delete',
  DocumentAnySetsAnyUpdate: 'document.*.sets.*.update',
  DocumentAnySetsAnyView: 'document.*.sets.*.view',
  EgressUpdate: 'egress.update',
  EgressView: 'egress.view',
  EnvelopesCreate: 'envelopes.create',
  EnvelopesDelete: 'envelopes.delete',
  EnvelopesUpdate: 'envelopes.update',
  EnvelopesView: 'envelopes.view',
  FormUpdate: 'form.update',
  FormView: 'form.view',
  IntegrationIllionBankStatementsRun: 'integration.illion.bank_statements.run',
  MessagesCreate: 'messages.create',
  MessagesEmailCreate: 'messages.email.create',
  MessagesView: 'messages.view',
  ModuleBrokerPortalAccess: 'module.broker_portal.access',
  ModuleDefaultAccess: 'module.default.access',
  ModuleMiddleOfficeAccess: 'module.middle_office.access',
  OrganisationsCreate: 'organisations.create',
  OrganisationsDelete: 'organisations.delete',
  OrganisationsUpdate: 'organisations.update',
  OrganisationsView: 'organisations.view',
  PermissionMatrixView: 'permission_matrix.view',
  PortalUsersCreate: 'portal_users.create',
  PortalUsersDelete: 'portal_users.delete',
  PortalUsersRestore: 'portal_users.restore',
  PortalUsersUpdate: 'portal_users.update',
  PortalUsersView: 'portal_users.view',
  ReportsCreate: 'reports.create',
  ReportsView: 'reports.view',
  RolesCreate: 'roles.create',
  RolesDelete: 'roles.delete',
  RolesUpdate: 'roles.update',
  RolesView: 'roles.view',
  SettingsCreate: 'settings.create',
  SettingsUpdate: 'settings.update',
  SettingsView: 'settings.view',
  StatusUpdate: 'status.update',
  UpdateMatrixVersionUpdate: 'update_matrix_version.update',
  UsersCreate: 'users.create',
  UsersDelete: 'users.delete',
  UsersRestore: 'users.restore',
  UsersTwoFactorAuthenticationUpdate: 'users.two_factor_authentication.update',
  UsersUpdate: 'users.update',
  UsersView: 'users.view',
  WorkbooksUpdate: 'workbooks.update',
  WorkbooksView: 'workbooks.view',
} as const;

export type Permission = (typeof Permissions)[keyof typeof Permissions];
export type PermissionName = keyof typeof Permissions;
